import React from "react";

import {
  Admin,
  Resource,
  //   ShowGuesser,
  //   EditGuesser,
} from "react-admin";

import { myDataProvider } from "../dataProvider/dataProvider";
import reducer from "../reducer";

import customRoutes from "../routes";
import carrierRoutes from "./carrierRoutes";

import { CarrierLayout } from "./layout/CarrierLayout";
import { CarrierUserList } from "./resources/carrierUsers/CarrierUserList";
import { CarrierUserCreate } from "./resources/carrierUsers/CarrierUserCreate";
import { CarrierEdit } from "./resources/carrierUsers/CarrierUserEdit";
import { CarrierShow } from "./resources/carrierUsers/CarrierUserShow";

import { useThemeState } from "../ThemeStateProvider";

// The shipment resources are registered but carry no routes of their own: the
// carrier reaches them at /deliveries and /pickups, mounted in carrierRoutes.
// The dashboard is a route there too, at /load-search, so the carrier's landing
// page has a URL of its own instead of only "/".
export const CarrierApp = ({ adminHistory }) => {
  const { selectedTheme } = useThemeState();

  return (
    <Admin
      disableTelemetry
      title="Transloads.co"
      options={{ authGroups: [] }}
      dataProvider={myDataProvider}
      layout={CarrierLayout}
      customRoutes={[...carrierRoutes, ...customRoutes]}
      customReducers={{ data: reducer }}
      theme={selectedTheme}
      history={adminHistory}
    >
      <Resource
        name="carrierUsers"
        list={CarrierUserList}
        create={CarrierUserCreate}
        edit={CarrierEdit}
        show={CarrierShow}
      />
      {/* Neither has routes of its own: the company profile is mounted at
          /company in carrierRoutes. Registered so the dataProvider answers
          getOne and update for them.

          Both, because the profile edits the company record while the yard entry
          is what the session names — the entry is read to find the company, and
          is still the form's subject for a carrier the stream has not placed
          yet. The plural is Amplify's own (listCarrierCompanys), which is what
          react-admin-amplify derives the operation names from. */}
      <Resource name="carriers" />
      <Resource name="carrierCompanys" />
      <Resource name="inboundShipments" />
      <Resource name="outboundShipments" />
      <Resource name="shipmentLineItems" />
      <Resource name="inventories" />
      <Resource name="accounts" />
      <Resource name="reloadYards" />
      <Resource name="areas" />
      <Resource name="reloadYardCommoditys" />
      <Resource name="truckEquipmentTypes" />
    </Admin>
  );
};
